export default __webpack_public_path__ + "static/media/logo-ceyba-light.a1b5d964.svg";